import { useQuery, UseQueryOptions, QueryKey } from '@tanstack/react-query';
import { apiFetch } from 'api/client';

export const useApiQuery = <TQueryFnData, TSelected = TQueryFnData>(
  queryKey: QueryKey,
  url: string,
  options?: Omit<UseQueryOptions<TQueryFnData, Error, TSelected, QueryKey>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<TQueryFnData, Error, TSelected, QueryKey>({
    queryKey,
    queryFn: () => apiFetch<TQueryFnData>(url),
    ...options
  });
};
